module.exports = __webpack_public_path__ + "name=img/src/assets/projects/design/e-commerce-store.png?e1f9efa1b9a8995077f4945a4a73de6d";